<template>
  <div
    ref="scrollContainer"
    class="scroll table-responsive scrollContainer no-vertical-scroll"
    :class="{ 'cursor-grab': canScroll, 'cursor-default': !canScroll }"
    @mousedown="startDrag"
    @mouseleave="stopDrag"
    @mouseup="stopDrag"
    @mousemove="onDrag"
  >
    <div class="table-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "ui-table",
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      canScroll: false,
    };
  },
  mounted() {
    this.updateCanScroll();
    window.addEventListener("resize", this.updateCanScroll);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateCanScroll);
  },
  methods: {
    updateCanScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;
      this.canScroll = el.scrollWidth > el.clientWidth;
    },
    startDrag(e) {
      if (!this.canScroll) return;
      this.isDragging = true;
      this.$refs.scrollContainer.classList.add("cursor-grabbing");
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
    },
    stopDrag() {
      this.isDragging = false;
      this.$refs.scrollContainer.classList.remove("cursor-grabbing");
    },
    onDrag(e) {
      if (!this.isDragging) return;
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walk = (x - this.startX) * -1;
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft + walk;
    },
  },
};
</script>

<style scoped>
.cursor-grab {
  cursor: grab;
}

.cursor-grabbing {
  cursor: grabbing !important;
}

.cursor-default {
  cursor: auto;
}
</style>